var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
// eslint-disable
/** bean: begin */
export * from '../bean/bean.theme.js';
import 'zova';
/** bean: end */
/** bean: begin */
import { BeanTheme } from '../bean/bean.theme.js';
import 'zova';
/** bean: end */
/** config: begin */
export * from '../config/config.js';
/** config: end */
/** monkey: begin */
export * from '../monkey.js';
/** monkey: end */
/** scope: begin */
import { BeanScopeBase } from 'zova';
import { Scope } from 'zova-module-a-bean';
export let ScopeModuleAStyle = (_dec = Scope(), _dec2 = __z_BeanInfo({
  module: "a-style"
}), _dec(_class = _dec2(_class = class ScopeModuleAStyle extends BeanScopeBase {}) || _class) || _class);
import 'zova';

/** scope: end */